import cx from 'classnames';
import * as React from 'react';
import { IViewBank } from '../../types/banksList';
import * as styles from './styles.css';

export const BanksList: React.FC<{ banksList: IViewBank[] }> = ({ banksList }) => {
  return (
    <div className={styles['banks-list']}>
      {banksList.map(({ fullsizeIcon }, index) => {
        return (
          <div className={cx(styles['bank'])} key={index}>
            <img src={fullsizeIcon} className={styles['bank-icon']} />
          </div>
        );
      })}
    </div>
  );
};
